import './style/Placeholder.css';
import React from 'react';
import { } from '../../redux/keystoneSlice';
import { } from '../../redux/keystoneInventorySlice';
import { Text } from '@harperai/materialize-design-system';
import Icon from './Icon';
import AllCaughtUp from '../../media/all-caught-up72@3x.png';
const Placeholder = ({ label }) => {

    return (
        <div className="keystone-placeholder product-vertical-container v-gap-m flex-1 align-center justify-center">
            <Icon icon={AllCaughtUp} color="#6f7aa5" size={54} />
            <Text header={2} size="h6" bold={true} variant="secondary">{label}</Text>
        </div>
    );
};

export default React.memo(Placeholder);